export default function Podmiot(props) {
  return <span id="a11y-podmiot">{props.children}</span>;
}
